<template>
  <div id="contenedor-detalles-solicitud-pago">
    <v-data-table
      :headers="headers"
      :items="listadoDetalles">
      <template
        v-slot:[`item.tipo`]="{ item }">
        <v-chip
          :color="item.color"
          dark
          pill>
          {{ item.tipo }}
        </v-chip>
      </template>
      <template
        v-slot:[`item.fechaFactura`]="{ item }">
        {{ new Date(`${item.fechaFactura} 00:00:0`).toLocaleDateString() }}
      </template>
      <template
        v-slot:[`item.archivoPdf`]="{ item }">
        <v-btn
          v-if="item.pdfPublicKey"
          icon
          @click="descargarArchivo(item, 'pdf')">
          <v-icon
            color="blue darken-1">
            mdi-cloud-download
          </v-icon>
        </v-btn>
      </template>
      <template
        v-slot:[`item.archivoXml`]="{ item }">
        <v-tooltip v-if="item.xmlPublicKey" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="descargarArchivo(item, 'xml')"
            >
              <v-icon
                color="blue darken-1">
                mdi-cloud-download
              </v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </template>
      <template
        v-slot:[`item.importe`]="{ item }">
        <v-chip
          class="font-weight-bold">
          {{ item.importe | currency }}
        </v-chip>
      </template>
      <template
        v-slot:[`item.acciones`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrarSolicitudPagoDetalle(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar Detalle</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'DetallesSolicitudPago',
  mixins: [mixDescargarArchivo],
  props: {
    listado: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        {
          text: '#',
          align: 'center',
          sortable: false,
          value: 'index',
        },
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: 'Número Factura', value: 'numeroFactura', sortable: false },
        { text: 'Fecha Factura', value: 'fechaFactura', sortable: false },
        {
          text: 'PDF', value: 'archivoPdf', align: 'center', sortable: false,
        },
        {
          text: 'XML', value: 'archivoXml', align: 'center', sortable: false,
        },
        {
          text: 'Monto', value: 'importe', align: 'end', sortable: false,
        },
        // { text: '', value: '', sortable: false },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    descargarArchivo(archivo, tipo) {
      const archivoDescargar = {
        publicKey: tipo === 'pdf' ? archivo.pdfPublicKey : archivo.xmlPublicKey,
        extension: tipo,
        nombre: `Factura ${archivo.tipo}_${archivo.numeroFactura}`,
      };
      this.mixDescargarArchivo(archivoDescargar, 'solicitudesPagos');
    },
    borrarSolicitudPagoDetalle(solicitudPagoDetalle) {
      eventBus.$emit('borrar-solicitud-pago-detalle', solicitudPagoDetalle);
    },
  },
  computed: {
    listadoDetalles() {
      return this.listado
        .map((detalle, index) => ({
          index: (index + 1),
          ...detalle,
        }))
        .map((detalle) => {
          let tipo = '';
          let color = '';
          // Si es tipo anticipo
          if (detalle.anticipo) {
            tipo = 'Anticipo';
            color = 'light-blue darken-1';
          }

          // Si es tipo estimacion
          if (detalle.estimacion) {
            tipo = 'Estimación';
            color = 'green darken-1';
          }

          // Si es tipo gasto
          if (detalle.gasto) {
            tipo = 'Gasto';
            color = 'pink darken-1';
          }

          // Si es tipo escalatoria
          if (detalle.escalatoria) {
            tipo = 'Escalatoria';
            color = 'brown darken-1';
          }

          return {
            ...detalle,
            tipo,
            color,
          };
        });
    },
  },
};
</script>

<style lang="scss">

</style>
